<template>
    <button
        class="delete_element_btn tooltipElement"
        @click="deleteElement"
    >
        <inline-svg
            :src="remove_icon"
            fill="#737373"
        />
        <Tooltip :tooltipText="`${$t('editorSceneElementOptionsDelete')}`" />
    </button>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import Tooltip from '@/components/Global/Tooltip.vue';
    import remove_icon from '@/assets/icons/panel_icons/trashcan.svg';

    export default {
        data() {
            return {
                remove_icon
            }
        },
        methods: {
            deleteElement() {
                this.$store.dispatch('REMOVE_PAGE_ELEMENT')
            }
        },
        components: {
            Tooltip
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .delete_element_btn {
        background-color: unset;
        border: none;
        border-right: 1px solid #D4D4D4;
        cursor: pointer;
        display: flex;
        align-content: center;
        justify-content: center;
    }
    .delete_element_btn:disabled {
        cursor: not-allowed;
    }
</style>